<script setup lang="ts">
import { ref } from 'vue';
import Cookies from 'js-cookie';

/** お気に入り登録IDを保持するCookieキー(pharmacistFavoriteCount()の実装を踏襲した固定値) */
const FAVORITE_POSITIONS_COOKIE_KEY = '_fp';

/**
 * Cookie `_fp`(カンマ区切りのお気に入り登録ID一覧)から件数を算出する。
 *
 * 事前条件: なし(Cookieが無い場合は0件として扱う)
 * 事後条件: 非負整数を返す
 * @returns {number} お気に入り件数
 */
const computeCount = (): number => {
  const cookieValue = Cookies.get(FAVORITE_POSITIONS_COOKIE_KEY);
  if (!cookieValue) return 0;

  return cookieValue.split(',').length;
};

/** ヘッダーに表示するお気に入り件数。マウント時にCookieから算出する。 */
const count = ref<number>(computeCount());

/**
 * Cookie `_fp` を読み直し、件数(`count` ref)を再計算する。
 * ref を書き換えるだけで、リアクティブな再描画がトリガーされる。
 *
 * 事前条件: なし
 * 事後条件: `count` が最新のCookie値に基づく件数に更新される
 */
const refresh = () => {
  count.value = computeCount();
};

defineExpose({
  refresh
});
</script>

<template>
  <span>{{ count }}</span>
</template>
